import { render, staticRenderFns } from "./ParticipantBody.vue?vue&type=template&id=55862ef4"
import script from "./ParticipantBody.vue?vue&type=script&lang=ts"
export * from "./ParticipantBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports